module.exports = __webpack_public_path__ + "8875bbbf4710928fcb9a3a1ed24351ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/fastcompany_h.png
// module id = 303
// module chunks = 3